import { AnyAction } from 'redux';
import { SELECTED_SINGIN_FORM, SIGN_IN_REQUEST, SIGN_IN_SUCCESS, SIGN_IN_FAILURE, CURRENT_USER, SIGN_OUT, SIGN_IN_ERROR_CLEAN } from '@app/store/constants';
import { loginForms } from '@app/enums';

const initialUserState = {
    form: loginForms.unknown,
    loggingIn: false,
    loggedIn: false,
    user: '',
    token: '',
    currentUser: {},
    error: {}
};

export function signIn(state = initialUserState, action: AnyAction) {
    const { payload, type } = action;

    switch (type) {
        case SELECTED_SINGIN_FORM:
            return {
                ...state,
                form: payload
            };

        case SIGN_IN_REQUEST:
            return {
                ...state,
                loggingIn: true,
                user: payload
            };
        case SIGN_IN_SUCCESS:
            return {
                ...state,
                loggingIn: false,
                loggedIn: true,
                token: payload
            };
        case SIGN_IN_FAILURE:
            return {
                ...state,
                loggingIn: false,
                loggedIn: false,
                error: payload
            };

        case SIGN_IN_ERROR_CLEAN:
            return {
                ...state,
                error: undefined
            };

        case CURRENT_USER:
            return {
                ...state,
                currentUser: payload
            };

        case SIGN_OUT:
            return {
                form: loginForms.unknown,
                loggingIn: false,
                loggedIn: false,
                user: '',
                token: '',
                currentUser: {},
                error: {}
            };

        default:
            return state;
    }
}
